import React from 'react';
//FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/style/calc.module.scss';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function _calc(props) {
    const { data } = props;

    const classFilter = (type) => {
        switch(data.CALC_YN) {
            case 'Y' : return type === 1 ? styles.success : type === 2 ? '정산완료' : null;
            case 'N' : return type === 1 ? styles.error : type === 2 ? '미정산' : null;
            default : return null;
        }
    }

    return (
        <Element tag={`div`} >
            <Element tag={`div`} className={styles.infoArea}>
                <Element tag={`label`}>{`${data.CALC_START_DATE} - ${data.CALC_END_DATE}`}</Element>
                <Element tag={`span`} className={styles.center}>정비 {data.STATE_4}건</Element>
                <Element tag={`span`} className={styles.center}>이력등록 {data.STATE_5}건</Element>
                <Element tag={`small`} className={classFilter(1)}>{classFilter(2)}</Element>
            </Element>
            <Element tag={`h1`}><span>정산금액</span><strong>{data.CALC_PRICE}원</strong></Element>
        </Element>
    );
}